import uuidv4 from 'uuid/v4';
import { SCROLL_DOWN_CHAT_HISTORY } from '../Actions/Constants';
const scrollDownInitState = {
    id: uuidv4(),
};
export function scrollBottomChatHistoryReducer(state = scrollDownInitState, action = {}) {
    if (action.type === SCROLL_DOWN_CHAT_HISTORY) {
        return action.payload;
    }
    return state;
}
